import {
  LuBoxes,
  LuBadgeCheck,
  LuDatabaseBackup,
  LuNotebookPen,
  LuSearchCheck,
} from 'react-icons/lu';

export const TransferIcon = () => (
  <LuDatabaseBackup className="workflow__icon-svg" aria-hidden="true" />
);

export const AnalysisIcon = () => (
  <LuSearchCheck className="workflow__icon-svg" aria-hidden="true" />
);

export const AgreementIcon = () => (
  <LuNotebookPen className="workflow__icon-svg" aria-hidden="true" />
);

export const ModelingIcon = () => (
  <LuBoxes className="workflow__icon-svg" aria-hidden="true" />
);

export const ResultIcon = () => (
  <LuBadgeCheck className="workflow__icon-svg" aria-hidden="true" />
);
